import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import React from 'react';
import { isMobile } from 'react-device-detect';

import { AppStore } from '@/stores';

import UserMenu from './user-menu.component';
// import Notification from './notification.component';

const Header: React.FC = () => {
  const openCloseSidebar = () => {
    AppStore.update((s) => {
      s.showSidebar = !s.showSidebar;
    });
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: '#17191d' }}>
        <Toolbar>
          {isMobile && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="toggle sidebar"
              onClick={openCloseSidebar}
            >
              <MenuIcon />
            </IconButton>
          )}

          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ display: 'flex' }}>
            {/* <Notification /> */}
            <UserMenu />
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
